export const NL_WEBSITES = ['www.nl.travelski.com', 'www.nl.yoonly.eu', 'cse.travelski.com|nl', 'www.benl.yoonly.eu', 'nl.travelski.com', 'benl.yoonly.eu', 'nl.yoonly.eu'];

export const UK_WEBSITES = ['www.uk.travelski.com', 'uk.travelski.com'];